<!-- Represents a single toast notification -->
<template>
  <div
    :class="['toast-notification small-text gap-xs gap-md-md px-xs py-sm', type, { centered }]"
    @click="emit('click')">
    <span class="icon d-flex align-items-center justify-content-center">
      <slot name="icon"/>
    </span>
    <span class="message">
      <template
        v-for="(text, index) in message"
        :key="index">
        <span v-if="typeof toValue(text) === 'string'">{{ toValue(text) }}</span>
        <span
          v-else
          :class="{ 'semi-bold': toValue(text).bold }">
          {{ toValue(text).text }}
        </span>
      </template>
    </span>
    <slot name="link">
      <BaseLink
        v-if="link"
        class="text-decoration-underline pointer"
        :to="link.to"
        @click="linkClick($event)">
        {{ link.text }}
      </BaseLink>
    </slot>
  </div>
</template>

<script setup>
import BaseLink from '@shared/components/BaseLink.vue'
import { toValue } from 'vue'

const props = defineProps({
  type: {
    type: String,
    required: true,
    validator: value => {
      return ['persistent', 'transient', 'smart'].includes(value)
    }
  },
  message: {
    type: [String, Array],
    required: true
  },
  link: {
    type: Object,
    default: null,
    validator: value => {
      return value.text && (value.to || value.clickHandler)
    }
  },
  centered: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['click'])

function linkClick (event) {
  props.link.clickHandler?.(event)
  event.stopPropagation()
}
</script>

<style lang="scss" scoped>

.toast-notification {
  color: white;
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  cursor: default;

  @include media-mobile {
    &.centered {
      grid-template-columns: repeat(3, auto);
      justify-content: center;
    }
  }

  &.pointer {
    cursor: pointer;
  }

  @include media-tablet-or-larger {
    padding: 12px 50px 12px 20px !important;
  }

  &, &.transient {
    background-color: $plum;
  }

  &.persistent {
    background-color: $orchid;
  }

  &.smart {
    background-color: $teal;
  }

  .icon {
    width: 20px;
    height: 20px;
  }

  .base-link {
    color: inherit;
  }
}
</style>
